/**
 * EVO — yetkazish ekranlarining URL holati.
 *
 * `lib/procurement-search.ts` bilan bir xil qoidalar:
 *   • URL ISHONCHSIZ KIRISH — har maydon tozalanadi;
 *   • DEFAULT qiymatlar URL ga YOZILMAYDI;
 *   • oq ro'yxatlar serverda takrorlanmaydi.
 *
 * ============================================================================
 * `unassigned` — URL DA BO'LSA BOR, BO'LMASA YO'Q. DEFAULT `true` EMAS.
 * ============================================================================
 * «Biriktirilmagan» — ekranning eng ko'p ishlatiladigan filtri (ertalabki
 * ish). Uni default yoqib qo'yish TAKLIF QILINDI va RAD ETILDI:
 *
 *   `/sales/deliveries` va `/sales/deliveries?unassigned=true` bir xil
 *   ro'yxatni ko'rsatardi, ya'ni manzil ekranda nima turganini AYTMAY
 *   qo'yardi. Omborchi hamkasbiga havola yuborsa, ikkinchisi «bugungi
 *   hammasi» ni ko'raman deb o'ylab, aslida filtrlangan ro'yxatni ochardi —
 *   va yo'q buyurtmani qidirib vaqt yo'qotardi.
 *
 * Buning o'rniga katakcha filtr panelida ENG CHAPDA turadi va bosilishi
 * bitta harakat. Yashirin holat bilan ko'rinadigan tugma o'rtasida — ikkinchisi.
 *
 * `unassigned=false` esa URL ga umuman yozilmaydi va serverga ham
 * yuborilmaydi: serverda u HECH QANDAY filtr qo'ymaydi (`deliveries.dto.ts`),
 * ya'ni «yo'q» qiymat bilan «filtrsiz» aynan bir xil narsa.
 */
import type { SortDir } from './products';
import type { DeliveryStatus } from './deliveries';
import { DELIVERY_STATUSES } from './deliveries';

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

function positiveInt(value: unknown): number | undefined {
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : undefined;
}

export interface DeliverySearch {
  readonly page?: number;
  readonly sortBy?: string;
  readonly sortDir?: SortDir;
  readonly q?: string;
  readonly status?: DeliveryStatus;
  readonly driverUserId?: number;
  /** Bitta KUN (`YYYY-MM-DD`), oraliq emas — `deliveries.dto.ts` dagi sabab. */
  readonly date?: string;
  readonly unassigned?: true;
}

export function parseDeliverySearch(search: Record<string, unknown>): DeliverySearch {
  const page = positiveInt(search.page);
  const driverUserId = positiveInt(search.driverUserId);
  const status =
    typeof search.status === 'string' &&
    (DELIVERY_STATUSES as readonly string[]).includes(search.status)
      ? (search.status as DeliveryStatus)
      : undefined;
  const date = typeof search.date === 'string' && ISO_DATE.test(search.date) ? search.date : undefined;

  return {
    ...(page !== undefined && page > 1 ? { page } : {}),
    ...(typeof search.sortBy === 'string' && search.sortBy !== '' ? { sortBy: search.sortBy } : {}),
    ...(search.sortDir === 'desc' ? { sortDir: 'desc' as SortDir } : {}),
    ...(typeof search.q === 'string' && search.q !== '' ? { q: search.q } : {}),
    ...(status ? { status } : {}),
    ...(driverUserId !== undefined ? { driverUserId } : {}),
    ...(date !== undefined ? { date } : {}),
    // Faqat `true` ma'noli — yuqoridagi izohga qarang.
    ...(search.unassigned === true || search.unassigned === 'true'
      ? { unassigned: true as const }
      : {}),
  };
}
